import gql from 'graphql-tag';

export default gql`
  query getListProductSupplier($input: GetListProductSupplierInput) {
    getListProductSupplier(input: $input) {
      data {
        id
        productId
        supplierId
        invoiceName
        invoiceUom
        supplierName
      }
      pageInfo {
        size
        page
        totalItems
        totalPages
      }
    }
  }
`;
